import React, { useContext } from 'react';
import classes from './NotEditablePrompt.module.scss';
import { TableKeys as Tab } from '../../../../models';
import { WMButton, WMButtonVariant } from '@walkme/wm-ui';
import { CreateAudienceDialogContext } from '../CreateAudienceDialogContext';
import { Error } from '@walkme/wm-ui-icons';
import { useTranslation } from 'react-i18next';

const keyPrefix = 'components.audiences.createAudienceDialog.notEditablePrompt';

const NotEditablePrompt = () => {
    const { t } = useTranslation('', { keyPrefix });
    const { dataTestId, redirectToNotification } = useContext(CreateAudienceDialogContext);

    return (
        <div className={classes.root} data-testid={`${dataTestId}-not-editable-prompt`}>
            <Error style={{ marginRight: 10 }} />
            <span className={classes.promptText}>
                {t('rulesNotEditable_fragment1')}
                <WMButton
                    variant={WMButtonVariant.Text}
                    className={classes.activeNotificationsButton}
                    onClick={async () => redirectToNotification?.(Tab.ACTIVE)}
                    tooltipProps={{ title: t('clickToView') }}
                    area-label={t('areaLabel')}
                >
                    {t('rulesNotEditable_fragment2')}
                </WMButton>
            </span>
        </div>
    );
};

export default NotEditablePrompt;
